import styles from './AboutUsSplitHero.module.css';

interface Props {
  imagePath: string;
  imageAlt: string;
  children: JSX.Element|JSX.Element[]
}

const AboutUsSplitHero = (props: Props) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img className={styles.image} src={props.imagePath} alt={props.imageAlt} />
    </div>
    <div className={styles.textContainer}>
      <div className={styles.textContainerInner}>
        {props.children}
      </div>
    </div>
  </div>
);

export default AboutUsSplitHero;